module.exports = __webpack_public_path__ + "img/cash-sync.6aee05a7.svg";